/**
 * The composer's product step: adding a product and restoring an archived one
 * without leaving the composer.
 *
 * A sibling file for the reason its siblings exist: `reviewRequests.composer.ts`
 * was 395 lines against this repo's 400-line hard limit. Spread back into
 * `reviewRequests.requests.composer.product` from there, so every key below is
 * `reviewRequests.requests.composer.product.*` and `@/locales/reviewRequests`
 * stays the one import path.
 *
 * The form's own labels, validation and per-status messages are NOT here: the
 * step reuses `Products/ProductCreateForm.vue` and `productRules.ts`, whose
 * copy lives under `reviewRequests.products.*`.
 *
 * Same two constraints as its siblings: English only, `{named}` placeholders.
 */
export const reviewRequestsProductStepMessages = {
  empty:
    "This client has no active review products yet. Add the first one to start a request.",
  emptyWithArchived:
    "This client has no active review products. Add one, or restore an archived one below, to start a request.",
  newProduct: "New product",
  archivedToggle: "Archived ({count})",
  restoring: "Restoring…",
  // The accessible name: a list of identical "Restore" buttons is ambiguous
  // out of context. The name is interpolated as text, never HTML.
  restoreNamed: "Restore {name}",
  // The unique index is per client and case-insensitive, archived rows
  // included — so the name is taken by a product the SAM can bring back.
  archivedMatch:
    "A product with this name is archived. Restore it from the archived list below.",
};
